export default __webpack_public_path__ + "static/media/cadenas.c40cf816.png";